import { render, staticRenderFns } from "./VideoPlayerCore.vue?vue&type=template&id=234b7592&lang=pug&"
import script from "./VideoPlayerCore.vue?vue&type=script&lang=ts&"
export * from "./VideoPlayerCore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports